module.exports = __webpack_public_path__ + "static/media/Icono In progress.dd978dc3.svg";